import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { onReadyCKE, CKEconfig } from "../config/CKE";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import {
	Typography,
	Grid,
	Card,
	CardContent,
	Hidden,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSnackbar } from "notistack";
import SetFile from "../components/SetFile";

const useStyles = makeStyles((theme) => ({
	form: {
		width: "100%", // Fix IE 11 issue.
	},
	submit: {
		margin: theme.spacing(2, 0, 1),
	},
	CKElabels: {
		marginTop: "1.5rem",
		fontWeight: "bold",
	},
}));

export default function SitesAdd(props) {
	const classes = useStyles();
	const [externalSite, setExternalSite] = useState({});
	const { enqueueSnackbar } = useSnackbar();
	const history = useHistory();

	const onChange = (e) => {
		setExternalSite({ ...externalSite, [e.target.name]: e.target.value });
	};

	const onChangeDescription = (e, editor) => {
		const data = editor.getData();
		setExternalSite({ ...externalSite, description: data });
	};

	const onSubmit = (e) => {
		e.preventDefault();
		fetch(`${process.env.REACT_APP_API_URL}/externalsites`, {
			method: "POST",
			credentials: "include",
			body: JSON.stringify(externalSite),
			headers: { "Content-Type": "application/json" },
		})
			.then((res) => res.json())
			.then((data) => {
				if (data.success) {
					enqueueSnackbar("External site added successfully!", {
						variant: "success",
					});
					history.push(`/${process.env.REACT_APP_ADMIN_URL}/externalsites`);
				} else {
					console.log(data);
					const errorArray = data.error.split(",");
					errorArray.forEach((error) => {
						enqueueSnackbar(`${error}`, { variant: "error" });
					});
				}
			});
	};

	return (
		<form className={classes.form} onSubmit={onSubmit}>
			<Grid container spacing={2}>
				<Grid item xs={12} sm={12} md={9}>
					<Typography component="h1" variant="h4">
						Add an External Site
					</Typography>
					<TextField
						variant="outlined"
						margin="normal"
						fullWidth
						id="name"
						label="Site Name"
						name="name"
						size="small"
						autoFocus
						onChange={onChange}
					/>
					<TextField
						type="url"
						variant="outlined"
						margin="normal"
						fullWidth
						id="url"
						label="Site URL"
						name="url"
						size="small"
						autoFocus
						onChange={onChange}
					/>
					<p className={classes.CKElabels}>Description*:</p>
					<CKEditor
						onReady={(editor) => {
							onReadyCKE(editor);
						}}
						editor={Editor}
						onChange={onChangeDescription}
						config={CKEconfig("Site description...")}
					/>
					<Button
						type="submit"
						fullWidth
						variant="contained"
						color="primary"
						className={classes.submit}
					>
						Save
					</Button>
				</Grid>
				<Grid item xs={12} sm={12} md={3}>
					<Card>
						<CardContent>
							<Hidden smDown>
								<Button
									type="submit"
									onClick={onSubmit}
									fullWidth
									variant="contained"
									color="primary"
									className={classes.submit}
								>
									Save
								</Button>
							</Hidden>
							<SetFile
								fileTitle="Featured Image"
								resource={externalSite}
								setResource={setExternalSite}
								imageOnly={true}
								fileLabel="featuredImage"
								fileLabelFileName="featuredImageFile"
							/>
						</CardContent>
					</Card>
				</Grid>
			</Grid>
		</form>
	);
}
